import { faFlaskVial } from '@fortawesome/pro-light-svg-icons';

import { MostSearchedResultType, SearchType } from '@/types/most-search-type';

type MostSearchedGroupLabel = Pick<MostSearchedResultType, 'title' | 'iconName'>;

export const mostSearchedGroupLabels: Partial<Record<SearchType, MostSearchedGroupLabel>> = {
  [SearchType.VACCINE]: {
    title: 'Vacinas',
    iconName: faFlaskVial,
  },
};
